import { GetExpressionDocument, GetExpressionQuery } from "@/generated/graphql";
import { ApolloQueryResult } from "@apollo/client/core";
import { generateApolloClient } from "../apolloClientUtil";
import { isOperatorGroupOther } from "../business";
import { GeneralConstant } from "../constant";
import { localStorageGetGroup } from "../localStorageUtil";

/**
 * 文言データを取得する
 * 運用管理者の場合、デフォルトの文言を取得する
 * @param chainCode チェーンコード
 * @param component 画面名
 * @param customerCode カスタマーコード
 * @return 文言データ
 */
export async function getWordList(
  chainCode: string,
  component: string,
  customerCode: string
): Promise<Record<string, string>> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();
    console.log(apolloClient);
    let _chainCode = chainCode;
    let _customerCode = customerCode;

    //運用管理者の場合、デフォルト文言を検索する
    if (isOperatorGroupOther(localStorageGetGroup())) {
      _chainCode = GeneralConstant.word_defalut_chain_key;
      _customerCode = GeneralConstant.word_defalut_customer_key;
    }

    const listWord: ApolloQueryResult<GetExpressionQuery> =
      await apolloClient.query<GetExpressionQuery>({
        query: GetExpressionDocument,
        variables: {
          chain_code: _chainCode,
          component: component,
          customer_code: _customerCode,
          version: "1.0",
        },
      });
    console.log(listWord);

    return JSON.parse(listWord.data.getExpression!.words!);
  } catch (err: unknown) {
    console.error(err);

    if (err instanceof Error) {
      err.message = "文言データの取得に失敗しました。";
      throw err;
    } else {
      throw new Error("文言データの取得に失敗しました。（Unknown error）");
    }
  }
}
